import { FaHandshake } from "react-icons/fa";
import colors from "core/resources/theme/colors";
import DashboardCard from "ui/components/Cards/DashboardCard";
import { useTotalAcordos } from "core/features/dashboards/hooks/useTotalAcordos";
import { useDashboardPrincipal } from "core/features/dashboards/store";

function CardAcordos() {
  const { query } = useDashboardPrincipal();
  const { data, isFetching } = useTotalAcordos(query);

  return (
    <DashboardCard
      isLoading={isFetching}
      positive={true}
      bg={colors.lightGray}
      label="Acordos feitos"
      valuePercent={null}
      value={data?.total ?? 0}
      icon={<FaHandshake fontSize="32px" color={colors.darkGray} />}
    />
  );
}

export default CardAcordos;
